export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-img4-17db22653ee98e32cbbf11a19dec7532.jpg";